export const TRADE_SECTION_ID = 'trades'
export const EXCLUSIONS_SECTION_ID = 'exclusions'

export default {
  TRADE_SECTION_ID: TRADE_SECTION_ID,
  EXCLUSIONS_SECTION_ID
}
